var $79b106fa346b6451$exports = {};
$79b106fa346b6451$exports = {
    "loading": `Na\u{10D}\xedtava sa...`,
    "loadingMore": `Na\u{10D}\xedtava sa viac...`
};


export {$79b106fa346b6451$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
